module.exports = __webpack_public_path__ + "static/media/48.be7e84ef.jpg";